import Axios from "axios";

export function GetAddress(cep, res) {
  Axios.get(`https://viacep.com.br/ws/${cep}/json`)
    .then(function (response) {
      let location = { country: "BR" };
      if (response.data.logradouro) {
        location.street = `${response.data.logradouro}`;
      }
      if (response.data.bairro) {
        location.neighborhood = `${response.data.bairro}`;
      }
      if (response.data.localidade) {
        location.city = `${response.data.localidade}`;
      }
      if (response.data.uf) {
        location.state = `${response.data.uf}`;
      }
      if (response.data.cep) {
        location.zipcode = response.data.cep.replace("-", "");
      }

      console.log("location", location);
      res(location);
    })
    .catch(function (error) {
      if (error) {
        console.error("Error fetching address:", error);
      }
    });
}

// The States array contains the long and short names of all Brazilian states.
// It can be used for dropdowns, forms, or any other UI elements that require a list of states.
export const States = [
  {
    longName: "Acre",
    shortName: "AC",
  },
  {
    longName: "Alagoas",
    shortName: "AL",
  },
  {
    longName: "Amapá",
    shortName: "AP",
  },
  {
    longName: "Amazonas",
    shortName: "AM",
  },
  {
    longName: "Bahia",
    shortName: "BA",
  },
  {
    longName: "Ceará",
    shortName: "CE",
  },
  {
    longName: "Distrito Federal",
    shortName: "DF",
  },
  {
    longName: "Espírito Santo",
    shortName: "ES",
  },
  {
    longName: "Goiás",
    shortName: "GO",
  },
  {
    longName: "Maranhão",
    shortName: "MA",
  },
  {
    longName: "Mato Grosso",
    shortName: "MT",
  },
  {
    longName: "Mato Grosso do Sul",
    shortName: "MS",
  },
  {
    longName: "Minas Gerais",
    shortName: "MG",
  },
  {
    longName: "Pará",
    shortName: "PA",
  },
  {
    longName: "Paraíba",
    shortName: "PB",
  },
  {
    longName: "Paraná",
    shortName: "PR",
  },
  {
    longName: "Pernambuco",
    shortName: "PE",
  },
  {
    longName: "Piauí",
    shortName: "PI",
  },
  {
    longName: "Rio de Janeiro",
    shortName: "RJ",
  },
  {
    longName: "Rio Grande do Norte",
    shortName: "RN",
  },
  {
    longName: "Rio Grande do Sul",
    shortName: "RS",
  },
  {
    longName: "Rondônia",
    shortName: "RO",
  },
  {
    longName: "Roraima",
    shortName: "RR",
  },
  {
    longName: "Santa Catarina",
    shortName: "SC",
  },
  {
    longName: "São Paulo",
    shortName: "SP",
  },
  {
    longName: "Sergipe",
    shortName: "SE",
  },
  {
    longName: "Tocantins",
    shortName: "TO",
  },
];
